module.exports = __webpack_public_path__ + "static/media/img_0.12cad094.png";